import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import SourceNotes from "@/pages/SourceNotes";

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/source-notes" element={<SourceNotes />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "hsl(222 40% 12%)",
            color: "hsl(40 33% 96%)",
            border: "1px solid hsl(40 70% 55% / 0.4)",
          },
        }}
      />
    </div>
  );
}

export default App;
